export default __webpack_public_path__ + "images/9f3c565e28905045210b3dedac780a39-fashion.png";